/**
 * (3156) Places the service sections in two columns that stack on their own,
 * so expanding one only pushes down the sections below it in the same column.
 * Sections alternate left and right in order. A lone section, or the last of
 * an odd number, spans the full width underneath.
 *
 * @template T
 * @param {T[]} sections
 * @returns {{ left: T[], right: T[], fullWidth: T | null }}
 */
export default function splitSectionColumns(sections) {
    const items = Array.isArray(sections) ? sections : [];
    const hasOddOneOut = items.length % 2 === 1;
    const paired = hasOddOneOut ? items.slice(0, -1) : items;

    return {
        left: paired.filter((_, index) => index % 2 === 0),
        right: paired.filter((_, index) => index % 2 === 1),
        fullWidth: hasOddOneOut ? items[items.length - 1] : null,
    };
}
